(ns practitest.frontend.components.tooltip
  (:require [reagent.core :as reagent]
            [reagent.dom]
            [goog.object :as gobj]
            [practitest.frontend.components.overlay :as overlay]
            ["react-bootstrap/OverlayTrigger" :as OverlayTrigger]
            ["react-bootstrap/Tooltip" :as Tooltip]
            [practitest.frontend.common.dom :as dom]
            [practitest.frontend.common.utils :refer [register-components!]]))

;; Hovering tooltip - simple tooltip component activated with delay on hovering/focusing
;
; [tooltip-body trigger-element] -> React element
;
; tooltip-body - Body of tooltip (reagent form)
; trigger-element-or-fn - Element to attach tooltip to (reagent form)
;                         or callback (fn [props] -> reagent form)
;
; If you're using simple element version then this component will add
; extra <span> wrapping trigger-element (for hovering/positioning logic)
; if this messes with formatting/CSS rules - use callback version and
; merge passed props on component that's supposed to be used for triggering
(defn
  ^{:deprecated "Use mux-tooltip instead"}
  hover-tooltip
  [tooltip-body trigger-element-or-fn options]
  [overlay/overlay-trigger
   options
   (fn [props]
     (reagent/create-element
       Tooltip
       props
       (reagent/as-element tooltip-body)))
   (fn [props]
     (if (fn? trigger-element-or-fn)
       ;; It's expected for child component to merge props map
       (reagent/as-element
         (trigger-element-or-fn (js->clj props)))

       ;; Wrapper span for handlers - can mess up CSS sometimes
       ;; Use callback version in that case
       (reagent/create-element
         "span"
         props
         (reagent/as-element trigger-element-or-fn))))])

;; TODO: https://github.com/react-bootstrap/react-bootstrap/pull/6544
(defn ^{:component? true}
  mux-tooltip
  "MouseUX styled tooltip component.

   Based on React Bootstrap OverlayTrigger element, see:
   https://react-bootstrap.netlify.app/docs/components/overlays/#overlaytrigger-1
   for details"
  [options tooltip-body trigger-element-fn]
  (let [root-node (atom nil)
        local-state (reagent/atom {:show? false})]
    (reagent/create-class
      {:component-did-mount (fn [this]
                              (let [node (dom/get-root-node (reagent.dom/dom-node this))]
                                (if (dom/in-shadow-dom? node)
                                  ;; Need this for tooltip to work in shadow DOM
                                  (reset! root-node node)

                                  ;; We need to fetch first div, otherwise
                                  ;; when working in non-shadow DOM mode and appending to <body>
                                  ;; causes annoying scrollbar flickering issues on some pages
                                  (reset! root-node (.querySelector node "div > div")))))
       :reagent-render
       (fn [options tooltip-body trigger-element-fn]
         (let [force-hide? (and (contains? options :hidden?)
                                (boolean (:hidden? options)))]
           [:r> OverlayTrigger
            #js {:placement    (or (:position options) "top")
                 :delay        (let [delay (:delay options)]
                                 #js {:show (or (and delay (:show delay)) 300)
                                      ;; 0 is not supported in OverlayTrigger
                                      :hide (or (and delay (:hide delay)) false)})
                 :onToggle     (fn [new-show]
                                 (if-some [on-toggle (:on-toggle options)]
                                   (on-toggle new-show)
                                   (swap! local-state assoc :show? new-show)))
                 :show         (cond
                                 (contains? options :show?)
                                 (:show? options)

                                 force-hide?
                                 false

                                 :else
                                 (:show? @local-state))
                 :trigger      (or (:trigger options)
                                   #js ["hover" "focus"])
                 :rootClose    true
                 :transition   true
                 :container    (fn []
                                 @root-node)
                 :overlay      (fn [props]
                                 (let [arrow-props (gobj/get props "arrowProps")]
                                   (gobj/set props "className" "mux-tooltip mux-tooltip-auto")

                                   (gobj/remove props "popper")
                                   (gobj/remove props "show")
                                   (gobj/remove props "arrowProps")

                                   (gobj/set arrow-props "className" "tooltip-arrow")

                                   ;; Additional logic for forced-hidden tooltips - otherwise
                                   ;; there's an annoying fade-out effect issues
                                   (if (or force-hide? (nil? tooltip-body))
                                     (reagent/create-element "div")

                                     ;; Actual tooltip
                                     (reagent/create-element
                                       "div"
                                       props

                                       ;; Arrow element
                                       (reagent/create-element "div" arrow-props)
                                       (reagent/create-element "div"
                                                               #js {:className "mux-tooltip-inner"}
                                                               (reagent/as-element tooltip-body))))))
                 :popperConfig (overlay/convert-popper-config {:offset   (or (:offset options) [0 11])
                                                               :strategy (:strategy options)})}

            (fn [props]
              (reagent/as-element (trigger-element-fn (js->clj props :keywordize-keys true))))]))})))

(register-components!)
